export const DATE_FORMAT_NUMERIC = 'YYYY-MM-DD';
export const DATE_FORMAT_HUMAN = 'MMM DD, YYYY';
export const DATE_FORMAT_HUMAN_TIME = 'h:mm A';
export const DATE_FORMAT_HUMAN_TIME_WITH_SECONDS = 'h:mm:ss A';
export const DATE_FORMAT_HUMAN_WITH_SECONDS = 'MMM DD, YYYY, h:mm:ss A';
export const DATE_FORMAT_HUMAN_WITH_MINUTES = 'MMM DD, YYYY, h:mm A';
export const DATE_FORMAT_TIME_SERIES_MINUTE = 'h:mm a';
export const DATE_FORMAT_TIME_SERIES_HOUR = 'MMM DD, ha';
export const DATE_FORMAT_TIME_SERIES_DAY = 'MMM DD';
export const DATE_FORMAT_TIME_SERIES_DAY_WITH_YEAR = 'MMM DD';
export const DATE_FORMAT_TIME_SERIES_MONTH = 'MMMM';
export const DATE_FORMAT_TIME_SERIES_YEAR = 'YYYY';
